import {
  mdiAccountCheckOutline,
  mdiAccountOutline,
  mdiAccountPlusOutline,
  mdiAccountRemoveOutline,
  mdiCogOutline,
  mdiDatabaseOutline,
  mdiDnsOutline,
  mdiPencilOutline,
} from '@mdi/js'
import { ref, watch } from '@vue/composition-api'
import store from '@/store'
import { useDatatablePagination } from '@/composables/useDatatablePagination'

export default function useAuthorsList() {
  const blankItem = {
    id: null,
    civility: null,
    ful_name: null,
    email: [],
    phone: null,
    avatar: null,
    source_id: null,
    status_id: null,
    user_id: null,
    old_author: null,
    addresses: [],
    password: null,
    changePassword: true,
    compte_auteur: null,
    social_number: null,
  }
  const form = ref(null)
  const items = ref([])
  const item = ref({})
  const downloadObject = ref({ loading: false, url: '' })
  const tableColumns = [
    {
      text: 'Actions',
      value: 'actions',
      align: 'center',
      sortable: false,
    },
    {
      text: 'Auteur', value: 'full_name', align: 'center', filter: { place_holder: '', type: 'text' },
    },
    {
      text: 'E-mail', value: 'email', align: 'center', filter: { place_holder: '', type: 'text' },
    },
    {
      text: 'Téléphone', value: 'phone', filter: { place_holder: '', type: 'text' }, align: 'center',
    },
    {
      text: 'Compte auteur', value: 'compte_auteur', filter: { place_holder: '', type: 'text' }, align: 'center',
    },
    {
      text: 'Pays',
      value: 'country.full_name',
      align: 'center',
      filter: {
        place_holder: '',
        type: 'select',
        values: store.state.app.pays,
        label: 'full_name',
        id: 'id',
        multiple: true,
        key: 'country_id',
        column: 'authors.country_id',
        join_table: 'countries',
        join_column: 'countries.id',
        local_column: 'authors.country_id',
      },
    },

    /* { text: 'Source', value: 'source.source_name', align: 'center',
      filter: {
        place_holder: '', type: 'select', values: store.state['app'].sources, label: 'source_name', id: 'id', multiple: true,
        column: 'authors.source_id',
        join_table: 'sources',
        join_column: 'sources.id',
        local_column: 'authors.format_id',
      }

      }, */
    {
      text: 'Anciens auteurs',
      value: 'old_author',
      align: 'center',
      filter: {
        place_holder: '', type: 'select', values: [{ id: 1, label: 'Anciens auteurs' }, { id: 0, label: 'Nouveaux auteurs' }], column: 'authors.old_author', label: 'label', id: 'id', multiple: false,
      },
    },
    {
      text: 'Cas particulier',
      value: 'particular_case',
      align: 'center',
      filter: {
        place_holder: '', type: 'select', values: [{ id: 'yes', label: 'Oui' }, { id: 'no', label: 'Non' }], column: 'authors.particular_case', label: 'label', id: 'id', multiple: false,
      },
    },
    {
      text: 'Auteur mineur',
      value: 'minor_author',
      align: 'center',
      filter: {
        place_holder: '', type: 'select', values: [{ id: 1, label: 'Oui' }, { id: 0, label: 'Non' }], column: 'authors.particular_case', label: 'label', id: 'id', multiple: false,
      },
    },
    {
      text: 'Publié',
      value: 'publish',
      align: 'center',
      filter: {
        place_holder: '', type: 'select', values: [{ id: 1, label: 'Publié' }, { id: 0, label: 'Non Publié' }], column: 'authors.publish', label: 'label', id: 'id', multiple: false,
      },
    },
  ]
  const tableColumnsGoogle = [
    {
      text: 'Auteur', value: 'full_name', align: 'center', filter: { place_holder: '', type: 'text' },
    },
    {
      text: 'E-mail', value: 'email', align: 'center', filter: { place_holder: '', type: 'text' },
    },
    {
      text: 'Téléphone', value: 'phone', filter: { place_holder: '', type: 'text' }, align: 'center',
    },
    {
      text: 'Pays',
      value: 'country.full_name',
      align: 'center',
      filter: {
        place_holder: '',
        type: 'select',
        values: store.state.app.pays,
        label: 'full_name',
        id: 'id',
        multiple: true,
        column: 'authors.country_id',
        join_table: 'countries',
        join_column: 'countries.id',
        local_column: 'authors.country_id',
      },
    },
  ]
  const isSnackbarBottomVisible = ref(false)
  const snackBarMessage = ref('')
  const isFormActive = ref(false)
  const deleteDialog = ref(false)
  const searchQuery = ref('')
  const payFilter = ref(null)
  const sourceFilter = ref(null)
  const statusFilter = ref(null)
  const totalItems = ref(0)
  const loading = ref(false)
  const filters = ref([])
  const exportType = ref(null)
  const { options, rowsPerPageItems } = useDatatablePagination()
  const page = ref(1)
  const pageCount = ref(0)
  const authorTotalLocal = ref([])
  const selectedRows = ref([])
  const resetForm = () => {
    if (form.value) form.value.reset()
  }

  // new item
  const openDialog = val => {
    if (val) {
      item.value = val
      item.value.addresses = item.value.addresses || []
    } else {
      item.value = JSON.parse(JSON.stringify(blankItem))
      resetForm()
    }
    isFormActive.value = !isFormActive.value
  }

  // fetch data
  const fetchAuthors = (download, opt = null) => {
    isFormActive.value = false
    downloadObject.value = { loading: true, url: null, ad: downloadObject.value.ad || null }
    const forAd = opt ? (opt.ad || null) : (downloadObject.value.ad || null)

    store
      .dispatch('app-author/fetchAuthors', {
        filters: filters.value.filter(ele => ele.filter != null && ele.filter.value !== '' && ele.filter.value != null && (ele.filter.value.constructor !== Array || ele.filter.value.length > 0))
          .map(ele => ({ ...ele.filter, key: ele.value, values: null })),
        term: searchQuery.value,
        status: statusFilter.value,
        pay: payFilter.value,
        source: sourceFilter.value,
        download,
        export_type: exportType.value,
        ad: forAd,
        orderBy: options.value.sortBy ? options.value.sortBy[0] : 'full_name',
        // eslint-disable-next-line no-nested-ternary
        direction: options.value.sortDesc ? (options.value.sortDesc[0] ? 'ASC' : 'DESC') : 'ASC',
        page: options.value.page,
        per_page: options.value.itemsPerPage,
      })
      .then(response => {
        if (download) {
          if (forAd) {
            downloadObject.value = {
              loading: false,
              ad: true,
              url: null,
            }
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            // File name (you can also extract this from the response headers)
            link.setAttribute('download', 'authors.csv')

            // Append to the document, trigger the download, and remove the link
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)

            return
          }
          downloadObject.value = {
            loading: false,
            url: response.data || null,
          }
        } else {
          const {
            data,
            total,
            authorTotal,
          } = response.data

          items.value = data.map(e => {
            e.old_author = e.old_author

            return e
          })
          store.commit('app-author/USERS', items.value)
          totalItems.value = total
          authorTotalLocal.value = authorTotal
        }

        // remove loading state
        loading.value = false
      })
      .catch(error => {
        console.log(error)
      })
  }
  const confirmDelete = val => {
    item.value = val
    deleteDialog.value = true
  }
  const deleteItem = () => {
    if (item.value) {
      loading.value = true
      store.dispatch('app-author/deleteAuthor', item.value)
        .then(response => {
          loading.value = false
          deleteDialog.value = false
          fetchAuthors()
          // eslint-disable-next-line no-unused-vars
        }).catch(error => {

        })
    }
  }

  const avatarText = value => {
    if (!value) return ''
    const nameArray = value.split(' ')

    return nameArray.map(word => word.charAt(0).toUpperCase()).join('')
  }
  // eslint-disable-next-line no-unused-vars
  let timeout = null
  watch([filters], () => {
    if (timeout) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(() => {
      if (!loading.value) {
        loading.value = true
        selectedRows.value = []
        fetchAuthors()
      }
    }, 1500)
  }, { deep: true })
  watch([searchQuery, payFilter, sourceFilter, statusFilter, options,exportType], () => {
    loading.value = true
    selectedRows.value = []
    fetchAuthors()
  }, { deep: true })

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveAuthorRoleVariant = pay => {
    if (pay === 'subscriber') return 'primary'
    if (pay === 'author') return 'warning'
    if (pay === 'maintainer') return 'success'
    if (pay === 'editor') return 'info'
    if (pay === 'administrator') return 'error'

    return 'primary'
  }

  const resolveAuthorRoleIcon = pay => {
    if (pay === 'subscriber') return mdiAccountOutline
    if (pay === 'author') return mdiCogOutline
    if (pay === 'maintainer') return mdiDatabaseOutline
    if (pay === 'editor') return mdiPencilOutline
    if (pay === 'administrator') return mdiDnsOutline

    return mdiAccountOutline
  }

  const resolveAuthorStatusName = status => {
    if (status === 0) return 'Inactif'
    if (status === 1) return 'Actif'

    return 'Actif'
  }

  const resolveAuthorStatusVariant = status => {
    if (status === 0) return 'warning'
    if (status === 1) return 'success'

    return 'primary'
  }

  const resolveAuthorTotalIcon = total => {
    if (total === 'Total Authors') return { icon: mdiAccountOutline, color: 'primary' }
    if (total === 'Paid Authors') return { icon: mdiAccountPlusOutline, color: 'error' }
    if (total === 'Active Authors') return { icon: mdiAccountCheckOutline, color: 'success' }
    if (total === 'Pending Authors') return { icon: mdiAccountRemoveOutline, color: 'warning' }

    return { icon: mdiAccountOutline, color: 'primary' }
  }

  return {
    downloadObject,
    item,
    items,
    filters,
    tableColumns,
    tableColumnsGoogle,
    exportType,
    searchQuery,
    payFilter,
    sourceFilter,
    statusFilter,
    totalItems,
    loading,
    options,
    rowsPerPageItems,
    authorTotalLocal,
    selectedRows,
    isFormActive,
    deleteDialog,
    confirmDelete,
    blankItem,
    form,
    page,
    pageCount,
    snackBarMessage,
    isSnackbarBottomVisible,
    avatarText,
    resetForm,
    openDialog,
    deleteItem,
    fetchAuthors,
    resolveAuthorRoleVariant,
    resolveAuthorRoleIcon,
    resolveAuthorStatusVariant,
    resolveAuthorStatusName,
    resolveAuthorTotalIcon,
  }
}
